import { continueProjectDataDownload, ensureProjectDataDownloaded } from 'serviceWorker/services/projectData';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { projectDataContract } from 'shared/domain/projectData/projectDataContract';

/** Answers the page's questions about the download of the selected project's data. */
export function serveProjectDataRequests(): ChannelUnsubscribe {
  return channelServer.handle(projectDataContract, {
    ensureDownloaded: ensureProjectDataDownloaded,
    continueDownload: continueProjectDataDownload,
  });
}
